// Sosyal Medya Yönetimi Faz 6b — müşteri portalındaki "Sosyal medya iletişiminiz" kartı (SALT OKUMA render).
//
// client-os.ts yükleme sırasında `window` global'lerine yazdığı için node testinde içe aktarılamıyor; saf render
// burada durur ve tests/omnichannel/firma-ozeti.test.js ile korunur (client-os-mesajlar.ts deseni).
//
// Kart YALNIZ sayı gösterir: mesaj metni, kişi adı ya da dış kimlik burada YOK. Uç kapalıysa (bayrak) veri null gelir
// ve kart hiç çizilmez.

import { escHtml } from '../utils.js';

export interface KanalPayi { kanal: string; gelen30: number }

export interface MarkaKarti {
  marka: string;
  markaAdi?: string | null;
  gelen30: number;
  gelen7: number;
  bekleyen: number;
  gecikti: number;
  medyanYanitDk: number | null;
  kanallar: KanalPayi[];
}

export interface FirmaOzeti {
  markalar: MarkaKarti[];
  toplam: { gelen30: number; gelen7: number; bekleyen: number; gecikti: number; medyanYanitDk: number | null };
}

const KANAL_ADI: Record<string, string> = {
  telegram: 'Telegram', whatsapp: 'WhatsApp', instagram_dm: 'Instagram mesajı', instagram_comment: 'Instagram yorumu',
  facebook_page: 'Facebook mesajı', facebook_comment: 'Facebook yorumu', web_form: 'Web formu', email: 'E-posta', manual: 'Elle kayıt',
};

export function kanalAdi(kanal: string): string {
  return KANAL_ADI[kanal] || kanal;
}

/** Dakikayı okunur süreye çevirir: 45 dk · 3 sa 10 dk · 2 gün 4 sa. */
export function sureMetni(dk: number | null): string {
  if (dk === null || !Number.isFinite(dk) || dk < 0) return '—';
  if (dk < 60) return `${Math.round(dk)} dk`;
  const saat = Math.floor(dk / 60);
  if (saat < 24) { const k = Math.round(dk % 60); return k ? `${saat} sa ${k} dk` : `${saat} sa`; }
  const gun = Math.floor(saat / 24); const ks = saat % 24;
  return ks ? `${gun} gün ${ks} sa` : `${gun} gün`;
}

function kutu(baslik: string, deger: string, alt = ''): string {
  return `<div class="gb-kpi" style="min-width:120px"><div class="gb-card-sub">${escHtml(baslik)}</div>
    <div style="font-size:20px;font-weight:600">${escHtml(deger)}</div>${alt ? `<div class="gb-card-sub">${escHtml(alt)}</div>` : ''}</div>`;
}

export function firmaOzetiKartiHtml(ozet: FirmaOzeti | null | undefined): string {
  if (!ozet || !Array.isArray(ozet.markalar) || !ozet.markalar.length) return '';
  const t = ozet.toplam;
  const kutular = [
    kutu('Son 30 gün', `${t.gelen30} mesaj`, `son 7 gün: ${t.gelen7}`),
    kutu('Ortanca yanıt süresi', sureMetni(t.medyanYanitDk)),
    kutu('Yanıt bekleyen', `${t.bekleyen} konuşma`, t.gecikti ? `${t.gecikti} tanesi 24 saati aştı` : ''),
  ].join('');
  const cokMarka = ozet.markalar.length > 1;
  const satirlar = ozet.markalar.map((m) => {
    const kanallar = m.kanallar.length ? m.kanallar.map((k) => `${kanalAdi(k.kanal)} ${k.gelen30}`).join(' · ') : '—';
    return `<tr><td>${escHtml(m.markaAdi || m.marka)}</td><td>${m.gelen30}</td><td>${m.gelen7}</td>
      <td>${escHtml(sureMetni(m.medyanYanitDk))}</td>
      <td>${m.bekleyen}${m.gecikti ? ` <span class="gb-pill gb-pill-muted">${m.gecikti} geç</span>` : ''}</td>
      <td>${escHtml(kanallar)}</td></tr>`;
  }).join('');
  const tablo = cokMarka || ozet.markalar[0].kanallar.length
    ? `<table class="gb-table" style="margin-top:10px"><thead><tr><th>Marka</th><th>30 gün</th><th>7 gün</th><th>Ortanca yanıt</th><th>Bekleyen</th><th>Kanallar</th></tr></thead><tbody>${satirlar}</tbody></table>`
    : '';
  return `<div class="gb-card">
    <div class="gb-card-title">💬 Sosyal medya iletişiminiz</div>
    <div class="gb-card-sub">Sayfalarınıza gelen mesaj ve yorumları sizin adınıza yanıtlıyoruz. Aşağıdaki sayılar son 30 günü kapsar.</div>
    <div style="display:flex;gap:10px;flex-wrap:wrap;margin-top:10px">${kutular}</div>
    ${tablo}
  </div>`;
}
